var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWolontariatIlustracjaSerce1 = function SvgWolontariatIlustracjaSerce1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Wolontariat_ilustracja_serce_1_svg__Warstwa_1",
    "data-name": "Warstwa 1",
    viewBox: "0 0 99.62 99.12"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Wolontariat_ilustracja_serce_1_svg__cls-3{fill:#e41f13}"))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h99.62v99.38H0z",
    style: {
      fill: "#d3c2ef"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.62 31.55V43.5h-13.6V31.55c0-.15 0-.3-.01-.44 0-.06 0-.12-.01-.18-.32-5.93-5.24-10.64-11.24-10.64S20.84 25 20.52 30.93c-.02.21-.02.41-.02.62V43.5h-6.35L7.27 31.58l-.38-.64C7.23 17.5 18.25 6.68 31.76 6.68c7.11 0 13.52 3 18.06 7.79 4.09 4.32 6.65 10.09 6.8 16.46v.62",
    className: "Wolontariat_ilustracja_serce_1_svg__cls-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.75 31.49 85.81 43.5h-6.67V31.55c0-.21 0-.42-.02-.62-.32-5.93-5.24-10.65-11.24-10.65S56.96 25 56.63 30.93c-.01.06-.01.12-.01.18v.04c-.01.13-.01.27-.01.4V43.5h-13.6V30.93c.16-6.37 2.71-12.14 6.8-16.46 4.53-4.79 10.95-7.79 18.06-7.79 13.51 0 24.53 10.82 24.87 24.25v.56Z",
    style: {
      fill: "#091f2c"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.75 31.49 85.81 43.5 75.03 62.16 57.55 92.44H42.4L25.28 62.81 14.13 43.5 7.25 31.58l-.38-.64 85.86-.01v.56Z",
    className: "Wolontariat_ilustracja_serce_1_svg__cls-3"
  })));
};
export default SvgWolontariatIlustracjaSerce1;